module.exports = __webpack_public_path__ + "static/media/Online Store 3.cacb61e8.png";